var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 16.0011,
    height: 16.0011,
    rx: 8.00056,
    fill: "#6F767E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13725_108948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14836 11.1496H5.12951C4.56758 11.1496 4.11084 10.6929 4.11084 10.131V5.87114C4.11084 5.30921 4.56758 4.85254 5.12951 4.85254H10.5005C11.0625 4.85254 11.5192 5.30921 11.5192 5.87114V8.24185C11.5192 8.3952 11.3947 8.51966 11.2414 8.51966C11.088 8.51966 10.9636 8.39554 10.9636 8.24185V5.87114C10.9636 5.61591 10.7558 5.40816 10.5005 5.40816H5.12951C4.87428 5.40816 4.66646 5.61591 4.66646 5.87114V10.131C4.66646 10.3862 4.87428 10.594 5.12951 10.594H8.14836C8.30171 10.594 8.42617 10.7184 8.42617 10.8718C8.42617 11.0251 8.30171 11.1496 8.14836 11.1496Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2414 6.88961H4.38871C4.23536 6.88961 4.1109 6.76515 4.1109 6.6118C4.1109 6.45844 4.23536 6.33398 4.38871 6.33398H11.2414C11.3948 6.33398 11.5193 6.45844 11.5193 6.6118C11.5193 6.76515 11.3948 6.88961 11.2414 6.88961Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87013 6.1486C5.71678 6.1486 5.59232 6.02414 5.59232 5.87078V4.38914C5.59232 4.23579 5.71678 4.11133 5.87013 4.11133C6.02348 4.11133 6.14794 4.23579 6.14794 4.38914V5.87078C6.14794 6.02414 6.02348 6.1486 5.87013 6.1486Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75969 6.1486C9.60633 6.1486 9.48187 6.02414 9.48187 5.87078V4.38914C9.48187 4.23579 9.60633 4.11133 9.75969 4.11133C9.91304 4.11133 10.0375 4.23579 10.0375 4.38914V5.87078C10.0375 6.02414 9.91304 6.1486 9.75969 6.1486Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13725_108948)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7779 8.99117C10.9732 8.79591 11.2898 8.79591 11.485 8.99117L11.7207 9.22688C11.916 9.42214 11.916 9.73872 11.7207 9.93398L9.98865 11.6661C9.96539 11.6893 9.93575 11.7052 9.90349 11.7116L9.01961 11.8884C8.90299 11.9117 8.80017 11.8089 8.82349 11.6923L9.00027 10.8084C9.00672 10.7762 9.02258 10.7465 9.04584 10.7233L10.7779 8.99117ZM11.2493 9.22688L11.485 9.46258C11.5501 9.52767 11.5501 9.63319 11.485 9.69828L11.2493 9.93398L10.7779 9.46258L11.0136 9.22688C11.0787 9.16179 11.1842 9.16179 11.2493 9.22688ZM10.5422 9.69828L9.31723 10.9233L9.19938 11.5125L9.78863 11.3947L11.0136 10.1697L10.5422 9.69828Z",
    fill: "#FCFCFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13725_108948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.89,
    height: 8.89,
    fill: "white",
    transform: "translate(3.55554 3.55664)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13725_108948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "white",
    transform: "translate(8.35535 8.35645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.670334b072bca2246ab97503d1c42b0c.svg";
export { ForwardRef as ReactComponent };